import {
  GET_BANK_UPLOADING,
  SET_BANK_UPLOADING,
  UPDATE_BANK_UPLOADING,
  DELETE_BANK_UPLOADING,
  SET_STATUS_LOADER,
  GET_BANK_UPLOADING_ID,
  SET_BANK_UPLOADING_ID,
} from "./actionType";

export const getBankUploading = data => ({
  type: GET_BANK_UPLOADING,
  payload: data,
});

export const setBankUploading = data => ({
  type: SET_BANK_UPLOADING,
  payload: data,
});

export const getBankUploadingById = id => ({
  type: GET_BANK_UPLOADING_ID,
  payload: id,
});

export const setBankUploadingById = data => ({
  type: SET_BANK_UPLOADING_ID,
  payload: data,
});

export const updateBankUploading = (id, data) => ({
  type: UPDATE_BANK_UPLOADING,
  payload: { id, data },
});

export const deleteBankUploading = id => ({
  type: DELETE_BANK_UPLOADING,
  payload: id,
});

export const stateLoaderBankUploading = () => ({
  type: SET_STATUS_LOADER,
});
